import React from 'react';

import { Container } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import Auth from './Auth';
import { init } from './Auth/thunk';
import Content from './Content';
import * as selectorsUser from './selector';

import type { PageType } from '@/domain/ui/redux';
import type { ModeAuthType, UserType } from '@/types/domain/user/redux';

import SCTActDialog from '@/domain/payment/component/SCTActDialog';
import { paymentSlice } from '@/domain/payment/redux';
import { uiSlice } from '@/domain/ui/redux';

const selectComponent = (user: UserType | undefined, modeAuth: ModeAuthType | undefined) => {
  if (user && user.attributes && modeAuth === 'home') {
    return <Content user={user} />;
  }
  return (
    <Auth user={user} mode={modeAuth} />
  );
};

const Main: React.FC = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectorsUser.userSelector);
  const modeAuth = useSelector(selectorsUser.modeSelector);
  const selectedNurseryId = useSelector(selectorsUser.selectedNurseryIdSelector);
  React.useEffect(() => {
    dispatch(init());
    // ウィンドウを閉じる際に確認する
    const handleBeforeunload = (event: { preventDefault: () => void; }) => {
      event.preventDefault();
    };
    window.addEventListener('beforeunload', handleBeforeunload);
    // 戻る動作の変更
    window.history.pushState({ page: 'home', prev: 'home' }, '');
    const handlePopstate = (
      event: { preventDefault: () => void; state: { page: PageType; }; },
    ) => {
      // eslint-disable-next-line no-console
      console.log(event?.state);
      if (event?.state?.page) {
        // eslint-disable-next-line no-alert
        const isDiscardedOK = window.confirm('前の画面に戻りますか？');
        if (isDiscardedOK) {
          dispatch(uiSlice.actions.backPage(event?.state?.page));
        }
      }
    };
    window.addEventListener('popstate', handlePopstate);

    return () => {
      window.removeEventListener('popstate', handlePopstate);
    };
  }, [dispatch]);
  const component = selectComponent(user, modeAuth);
  return (
    <Container maxWidth="lg" style={{ margin: '10px auto' }}>
      {component}
      {selectedNurseryId && (
        <SCTActDialog
          close={() => dispatch(paymentSlice.actions.setSelectedNurseryId(null))}
          nurseryId={selectedNurseryId}
        />
      )}
    </Container>
  );
};

export default Main;
